import React, { useState, useEffect } from 'react';
import styles from './solucon_financeira.module.scss';
import { Shield, Award, Clock, X } from 'lucide-react';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';

const ANO_ATUAL = new Date().getFullYear();

const CONSIGNADO_OPCOES = [
    { label: 'INSS', descricao: 'Empréstimo consignado para aposentados e pensionistas do INSS. Parcelas descontadas direto no benefício, com taxas competitivas e aprovação ágil.' },
    { label: 'CLT', descricao: 'Consignado para trabalhadores com carteira assinada. Desconto em folha de pagamento, sem consulta ao SPC/Serasa em muitas propostas.' },
    { label: 'Governo', descricao: 'Linhas de crédito consignado para servidores públicos federais, estaduais e municipais. Condições especiais para quem tem vínculo estável.' },
    { label: 'Prefeitura', descricao: 'Empréstimo consignado para servidores de prefeituras. Desconto direto no contracheque, com prazos e parcelas que cabem no seu orçamento.' },
    { label: 'FGTS', descricao: 'Antecipação de saque-aniversário do FGTS. Use o saldo do fundo como garantia e receba o valor com as condições que combinarem.' },
    { label: 'Siape', descricao: 'Consignado para servidores cadastrados no Siape. Oferecemos simulação e análise sem compromisso para você comparar as melhores taxas.' },
];

const ICONS_ROW = [
    { icon: Shield, label: 'Segurança' },
    { icon: Award, label: 'Confiança' },
    { icon: Clock, label: 'Agilidade' },
];

type ConsignadoItem = typeof CONSIGNADO_OPCOES[number];

const Solucon_financeira: React.FC = () => {
    const [modalConsignado, setModalConsignado] = useState<ConsignadoItem | null>(null);

    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setModalConsignado(null);
        };
        if (modalConsignado) {
            document.addEventListener('keydown', handleEsc);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = '';
        };
    }, [modalConsignado]);

    const openWhatsApp = (phone: string, name: string) => {
        const msg = encodeURIComponent(`Olá ${name}, vim pelo cartão digital da Solucon Financeira e gostaria de mais informações.`);
        window.open(`https://wa.me/55${phone.replace(/\D/g, '')}?text=${msg}`, '_blank');
    };

    const LOCATION_URL = 'https://maps.app.goo.gl/6cma3E18RS78jzxb7';

    const openLocation = () => {
        window.open(LOCATION_URL, '_blank');
    };

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.header}>
                <img
                    src={require('./src/logo.png')}
                    alt="Solucon Financeira"
                    className={styles.logo}
                />
            </div>
            <div className={styles.headerDivider} />

            <div className={styles.body}>
                <div className={styles.iconsRow}>
                    {ICONS_ROW.map((item, index) => {
                        const Icon = item.icon;
                        return (
                            <div key={index} className={styles.iconItem}>
                                <div className={styles.iconCirclePegada}>
                                    <Icon size={28} color="#0A3F6D" strokeWidth={2} />
                                </div>
                                <span className={styles.iconLabel}>{item.label}</span>
                            </div>
                        );
                    })}
                </div>

                <div className={styles.section}>
                    <p className={styles.sectionTitle}>CONSIGNADO PARA</p>
                    <div className={styles.chips}>
                        {CONSIGNADO_OPCOES.map((opcao, index) => (
                            <button
                                key={index}
                                type="button"
                                className={styles.chip}
                                onClick={() => setModalConsignado(opcao)}
                            >
                                {opcao.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className={styles.section}>
                    <p className={styles.consultoresText}>Fale com um de nossos consultores</p>
                    <div className={styles.buttonsRow}>
                        <button
                            type="button"
                            className={styles.btnWhatsapp}
                            onClick={() => openWhatsApp('17991611942', 'Jaqueline')}
                        >
                            <WhatsappIcon height="22" color="#fff" />
                            <span>Jaqueline Mesquita</span>
                        </button>
                        <button
                            type="button"
                            className={styles.btnWhatsapp}
                            onClick={() => openWhatsApp('17992276578', 'Victor')}
                        >
                            <WhatsappIcon height="22" color="#fff" />
                            <span>Victor Mesquita</span>
                        </button>
                        <button
                            type="button"
                            className={styles.btnLocation}
                            onClick={openLocation}
                        >
                            <MapsIcon height="22" color="#fff" />
                            <span>Localização</span>
                        </button>
                    </div>
                </div>
            </div>

            {modalConsignado && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setModalConsignado(null)}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-title"
                >
                    <div
                        className={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className={styles.modalHeader}>
                            <h3 id="modal-title" className={styles.modalTitle}>{modalConsignado.label}</h3>
                            <button
                                type="button"
                                className={styles.modalClose}
                                onClick={() => setModalConsignado(null)}
                                aria-label="Fechar"
                            >
                                <X size={22} strokeWidth={2} />
                            </button>
                        </div>
                        <p className={styles.modalDescricao}>{modalConsignado.descricao}</p>
                    </div>
                </div>
            )}

            <div className={styles.footer}>
                <p className={styles.footerText}>
                    © {ANO_ATUAL} Solucon Financeira — Todos os direitos reservados
                </p>
            </div>
        </div>
    );
};

export default Solucon_financeira;
